import axios from 'axios';

export const userService = {
  getUsers: () => axios.get('/users', { auth: true }),
  createUser: (data) => axios.post('/users', data, { auth: true }),
  editUser: (id, data) => axios.patch(`/users/${id}`, data, { auth: true }),
};
